<authority-labs-check-case
  [inspection]="inspection"
  [fieldSection]="fieldSection"
  [printPreview]="printPreview"
  [readonly]="readonly"
  [hideConclusion]="true"
  [hideConclusion]="true"
  [hideNotes]="true"
  (dataChange)="onChange()"
>
  <mat-tab-group
    class="mat-elevation-z4"
    [(selectedIndex)]="selectedTab"
    *ngIf="!printPreview"
  >
    <mat-tab *ngFor="let activationRegime of inspection.data; let ind = index">
      <ng-template mat-tab-label>
        <mat-icon class="fail" color="warn" *ngIf="!activationRegime.isPassed">
          priority_high
        </mat-icon>
        <span>{{ tabName(ind) }}</span>
      </ng-template>
      <ng-template matTabContent>
        <div [style.margin-right]="readonly || printPreview ? '45px' : '0'">
          <ng-container
            *ngTemplateOutlet="
              tableTpl;
              context: {
                activationRegime: activationRegime,
                actions: activationRegime.actions,
                events: activationRegime.events,
                ind: ind
              }
            "
          ></ng-container>
        </div>
        <section *ngIf="!(readonly || printPreview)">
          <button
            class="btn remove-btn"
            mat-raised-button
            aria-label="remove"
            [disabled]="inspection.data.length === 1"
            (click)="removeActivationRegime()"
          >
            <span>הסר</span>
          </button>
          <button
            class="btn add-btn"
            mat-raised-button
            color="accent"
            aria-label="duplicate"
            (click)="duplicateActivationRegime()"
          >
            <span>שכפל</span>
          </button>
          <button
            class="btn add-btn"
            mat-raised-button
            color="accent"
            aria-label="add"
            (click)="addActivationRegime()"
          >
            <span>הוסף</span>
          </button>
        </section>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</authority-labs-check-case>

<ng-template
  #tableTpl
  let-activationRegime="activationRegime"
  let-actions="actions"
  let-events="events"
  let-ind="ind"
>
  <table class="data boundary">
    <thead>
      <tr>
        <th rowspan="2" class="main-cell">
          <div>
            <div class="input">
              <p>INPUT</p>
              <p>(אירוע)</p>
              <button
                nz-button
                nzType="text"
                nz-dropdown
                [nzDropdownMenu]="eventsMenu"
                *ngIf="!readonly"
              >
                <i nz-icon nzType="plus"></i>
              </button>
              <nz-dropdown-menu #eventsMenu="nzDropdownMenu">
                <ul nz-menu>
                  <li nz-menu-item (click)="addNewEvent(events)">הוסף חדש</li>
                  <li nz-menu-item (click)="addEvents(events)">
                    הוסף מבנק הערות
                  </li>
                </ul>
              </nz-dropdown-menu>
            </div>
            <div class="output">
              <p>OUTPUT</p>
              <p>(תגובה)</p>
            </div>
          </div>
        </th>

        <th class="group" [colspan]="actions?.alerts?.length || 1">
          <div class="col-title">
            <span>התראות, התרעות ודיווחים</span>
            <button
              nz-button
              nzType="text"
              nz-dropdown
              [nzDropdownMenu]="alertsMenu"
              *ngIf="!readonly"
            >
              <i nz-icon nzType="plus"></i>
            </button>
            <nz-dropdown-menu #alertsMenu="nzDropdownMenu">
              <ul nz-menu>
                <li nz-menu-item (click)="addNewAction(actions.alerts)">
                  הוסף חדש
                </li>
                <li nz-menu-item (click)="addActions('alerts', actions.alerts)">
                  הוסף מבנק הערות
                </li>
              </ul>
            </nz-dropdown-menu>
          </div>
        </th>
        <th class="group" [colspan]="actions?.smoke?.length || 1">
          <div class="col-title">
            <span>שליטה בעשן</span>
            <button
              nz-button
              nzType="text"
              nz-dropdown
              [nzDropdownMenu]="smokeMenu"
              *ngIf="!readonly"
            >
              <i nz-icon nzType="plus"></i>
            </button>
            <nz-dropdown-menu #smokeMenu="nzDropdownMenu">
              <ul nz-menu>
                <li nz-menu-item (click)="addNewAction(actions.smoke)">
                  הוסף חדש
                </li>
                <li nz-menu-item (click)="addActions('smoke', actions.smoke)">
                  הוסף מבנק הערות
                </li>
              </ul>
            </nz-dropdown-menu>
          </div>
        </th>
        <th class="group" [colspan]="actions?.fireSeperation?.length || 1">
          <div class="col-title">
            <span>הפרדות אש</span>
            <button
              nz-button
              nzType="text"
              nz-dropdown
              [nzDropdownMenu]="fireSeperationMenu"
              *ngIf="!readonly"
            >
              <i nz-icon nzType="plus"></i>
            </button>
            <nz-dropdown-menu #fireSeperationMenu="nzDropdownMenu">
              <ul nz-menu>
                <li nz-menu-item (click)="addNewAction(actions.fireSeperation)">
                  הוסף חדש
                </li>
                <li
                  nz-menu-item
                  (click)="addActions('fireSeperation', actions.fireSeperation)"
                >
                  הוסף מבנק הערות
                </li>
              </ul>
            </nz-dropdown-menu>
          </div>
        </th>
        <th class="group" [colspan]="actions?.systems?.length || 1">
          <div class="col-title">
            <span>שליטה במערכות</span>
            <button
              nz-button
              nzType="text"
              nz-dropdown
              [nzDropdownMenu]="systemsMenu"
              *ngIf="!readonly"
            >
              <i nz-icon nzType="plus"></i>
            </button>
            <nz-dropdown-menu #systemsMenu="nzDropdownMenu">
              <ul nz-menu>
                <li nz-menu-item (click)="addNewAction(actions.systems)">
                  הוסף חדש
                </li>
                <li
                  nz-menu-item
                  (click)="addActions('systems', actions.systems)"
                >
                  הוסף מבנק הערות
                </li>
              </ul>
            </nz-dropdown-menu>
          </div>
        </th>
      </tr>

      <tr class="sideway">
        <ng-container
          *ngFor="
            let group of [
              { key: 'alerts', items: actions.alerts },
              { key: 'smoke', items: actions.smoke },
              { key: 'fireSeperation', items: actions.fireSeperation },
              { key: 'systems', items: actions.systems }
            ]
          "
        >
          <th [attr.colspan]="group.items.length || 1" class="group-reorder-th">
            <div
              cdkDropList
              cdkDropListOrientation="horizontal"
              [cdkDropListData]="group.items"
              (cdkDropListDropped)="dropAction($event)"
              class="group-drop-list"
            >
              <div
                *ngFor="let action of group.items; let i = index"
                class="action-cell"
                cdkDrag
                cdkDragLockAxis="x"
                cdkDragPreviewClass="column-drag-preview"
                [cdkDragDisabled]="readonly || !(group.items.length > 1)"
                [cdkDragData]="{ items: group.items, index: i }"
              >
                <div class="action-col">
                  <span class="action-name">{{ action }}</span>
                  <div class="actions" *ngIf="!readonly">
                    <div
                      cdkDragHandle
                      class="action-drag-handle action"
                      *ngIf="!readonly && group.items.length > 1"
                    >
                      <authority-labs-drag-icon
                        size="16px"
                      ></authority-labs-drag-icon>
                    </div>
                    <button
                      nz-button
                      nzType="text"
                      (click)="editAction(i, group.items)"
                      class="action"
                    >
                      <i nz-icon nzType="edit"></i>
                    </button>
                    <button
                      nz-button
                      nzType="text"
                      (click)="deleteAction(i, group.items)"
                      class="action"
                    >
                      <i nz-icon nzType="delete-column"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div
                class="empty-placeholder"
                *ngIf="group.items.length === 0"
              ></div>
            </div>
          </th>
        </ng-container>
      </tr>
    </thead>

    <tbody
      cdkDropList
      cdkDropListLockAxis="y"
      (cdkDropListDropped)="dropEvent($event, events)"
      class="events-boundary"
    >
      <tr *ngFor="let event of events; let i = index" class="event-row">
        <td
          class="event-col"
          cdkDrag
          cdkDragRootElement="tr"
          cdkDragLockAxis="y"
          cdkDragPreviewClass="event-row-preview"
          cdkDragBoundary=".events-boundary"
          [cdkDragDisabled]="readonly"
        >
          <div>
            <div class="event-name">
              <div cdkDragHandle class="drag-handle" *ngIf="!readonly">
                <authority-labs-drag-icon></authority-labs-drag-icon>
              </div>
              <span>{{ event.name }} </span>
            </div>
            <div class="event-actions">
              <button
                nz-button
                nzType="text"
                (click)="editEvent(i, events)"
                *ngIf="!readonly"
              >
                <i nz-icon nzType="edit"></i>
              </button>
              <button
                nz-button
                nzType="text"
                (click)="deleteEvent(i, events)"
                *ngIf="!readonly"
              >
                <i nz-icon nzType="delete-row"></i>
              </button>
            </div>
          </div>
        </td>
        <ng-container
          *ngFor="
            let actionsList of [
              actions.alerts,
              actions.smoke,
              actions.fireSeperation,
              actions.systems
            ]
          "
        >
          <td
            class="status-cell"
            *ngFor="let action of actionsList"
            (click)="toggleConclusion(event, action)"
          >
            <div [ngSwitch]="isPassed(event, action)">
              <mat-icon *ngSwitchCase="Conclusion.Pass">check</mat-icon>
              <mat-icon *ngSwitchCase="Conclusion.Fail" color="warn"
                >close</mat-icon
              >
              <mat-icon *ngSwitchCase="Conclusion.NotApplicable"
                >remove</mat-icon
              >
              <mat-icon *ngSwitchDefault>remove</mat-icon>
            </div>
          </td>
          <td class="empty" *ngIf="actionsList.length === 0"></td>
        </ng-container>
      </tr>
    </tbody>
  </table>

  <br />
  <mat-form-field
    floatLabel="always"
    appearance="fill"
    class="textarea margin-right"
  >
    <mat-label>מלל חופשי (יופיע בתעודה)</mat-label>
    <textarea
      matInput
      cdkTextareaAutosize
      [(ngModel)]="activationRegime.value"
      [readonly]="readonly || printPreview"
      (input)="onChange()"
    ></textarea>
  </mat-form-field>

  <div class="notes">
    <authority-labs-check-notes
      [notes]="activationRegime.notes"
      [printPreview]="printPreview"
      [readonly]="readonly"
      [type]="activationRegime.title"
      (dataChange)="onChange()"
    ></authority-labs-check-notes>
  </div>
</ng-template>
